import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import reportWebVitals from '../reportWebVitals';

import { Provider } from 'react-redux'
import zhCN from 'antd/lib/locale/zh_CN';
import { ConfigProvider } from 'antd';
import store from '../store'

// import store from './store'

ReactDOM.render(
  <Provider store={store}>
    <ConfigProvider locale={zhCN} autoInsertSpaceInButton={false}>
      <App />
    </ConfigProvider>
  </Provider>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
